import { unsubscribeSubscriptions,isAspCrmIntegrationEnabled,isAspDmsIntegrationEnabled } from '../../../../modules/shared/services/util.service';
import { SubscriptionList } from '../../../..//modules/shared/models/asp.types';
import { ConfirmDialogComponent } from './../../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IServiceOpcodes, OpCodeState } from './../../../store/opcode/opcode.reducer';
import { Store } from '@ngrx/store';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import * as OpCodeActions from './../../../store/opcode/opcode.actions';
import * as fromSelector from '../../../store/opcode/opcode.selectors';
import { AllOpcodeSortBy, IServiceOpcode, OnlineOpcodeSortBy, SortOrder, ISyncStatus, OpcodeType, IOnlineCodeSortDetail } from '@signal/asp-data-commons';
import { OtherServiceOpcodeComponent } from '../other-service-opcode/other-service-opcode.component';
import { TranslateService } from '@ngx-translate/core';
import { CreateOpcodeFormComponent } from '../create-opcode-form/create-opcode-form.component';
import { AlertService } from '../../../shared/services/alert.service';
import * as _ from "lodash";

@Component({
  selector: 'app-opcode-service-list',
  templateUrl: './opcode-service-list.component.html',
  styleUrls: ['./opcode-service-list.component.scss']
})
export class OpcodeServiceListComponent implements OnInit, OnDestroy {
  opCodeListForm: UntypedFormGroup;

  limit = 10;
  offset = 0;
  offsetThreshold = 0;
  skipCounter = 0;
  allLoadedAbove = false;
  allLoadedBelow = false;
  loading = false;
  aspServiceCode: any= null;
  isSelected: string = null;
  index = -1;

  allOpCodes$: Observable<IServiceOpcode[]>;
  allOpCodes: IServiceOpcodes;
  allOpCodesArray: IServiceOpcode[];
  allOpcodesLoading$: Observable<boolean>;
  allLoadedBelow$: Observable<boolean>;
  limit$: Observable<number>;
  offsetThreshold$: Observable<number>;
  skipCounter$: Observable<number>;
  loading$: Observable<boolean>;
  onlineOpcodesLoading$: Observable<boolean>;
  allOpCodesCount$: Observable<number>;
  onlineOpCodesCount: number = 0;
  syncStatus$: Observable<ISyncStatus>;
  isDmsIntegrated:boolean;
  isCrmIntegrated:boolean;
  onlineOpcodesArray: IServiceOpcode[];
  onlineOpcodes: IServiceOpcodes;

  newOnlineOpCodes: IServiceOpcode[] = [];
  aspOnlineOpCodes: IServiceOpcode[] = [];
  recommendedOnlineOpCodes: IServiceOpcode[] = [];
  regularOnlineOpCodes: IServiceOpcode[] = [];

  onlineServicesSortOrder: IOnlineCodeSortDetail;

  selectedOpcode: string;
  selectedOpcodeListFromAll: IServiceOpcode[] = [];
  selectedOpcodeListFromOnline: IServiceOpcode[] = [];
  selectedOpcodeListFromAllCategory= {};
  selectedOpcodeListFromOnlineCategory = {};

  refreshInterval;
  isAllOpCodeList: boolean;
  private subs: SubscriptionList = {};
  isEnglishTranslation:boolean = true;
  isSortingAllOpcodes = false;
  sortedAllOpcodes : IServiceOpcode[] = [];
  allOpcodesObject = {};
  aspModalContainer : string = 'asp-modal-container';
  isSearchLoading = false;
  private isDmsSyncInProgress = false;

  @Output()  formEdited:EventEmitter<boolean>=new EventEmitter();
  @Input() saveClicked:EventEmitter<boolean>=new EventEmitter();
  categories = ['maintenanceOpcodes', 'complaintOpcodes', 'dmsOpcodes' ]
  categoriesTranslation = { 
    'maintenanceOpcodes': 'opcodeServiceManagement.maintenanceCodes', 'complaintOpcodes': 'opcodeServiceManagement.complaintCodes',
     'dmsOpcodes' : 'opcodeServiceManagement.dmsOpcodes'
  
}
isOnlineOpcodesExpandAll = false;

  private readonly removeCustomSortConfig = {
    width: '400px',
    height: '240px',
    data: {
      popupTitle: 'opcodeServiceManagement.confirmation',
      popupBodyText: 'opcodeServiceManagement.changingTheOnlineSortingToAlphabeticalOrderWillResetAllCustomSortSettingsPreviouslyConfigured.DoYouWishToContinue?'
    },
    panelClass: this.aspModalContainer
  };

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly opCodeStore: Store<OpCodeState>,
    public dialog: MatDialog,
    private readonly translate: TranslateService,
    private readonly alertService: AlertService) {
  }

  //forms are edited
   formsEdited(event)
   {
    this.formEdited.emit(event);
   }

  ngOnInit(): void {
    
    this.isCrmIntegrated = isAspCrmIntegrationEnabled;
    this.isDmsIntegrated = isAspDmsIntegrationEnabled;
    this.isEnglishTranslation = this.translate.currentLang?.includes('es') ? false : true;
    this.initializeForm();

    this.reloadOpCodes();
    this.loadOnlineOpCodeDetails();
    this.allOpCodes$ = this.opCodeStore.select(fromSelector.selectOpCodes);

    this.onlineOpcodesLoading$ = this.opCodeStore.select(fromSelector.selectOnlineOpCodeLoading);
    this.allOpcodesLoading$ = this.opCodeStore.select(fromSelector.selectLoading);
    this.loading$ = this.opCodeStore.select(fromSelector.selectUpdateOpCodeLoading);
    this.allOpCodesCount$ = this.opCodeStore.select(fromSelector.selectAllOpCodeCount);
    this.syncStatus$ = this.opCodeStore.select(fromSelector.selectSyncStatus);
    this.subs.syncstatus = this.syncStatus$.subscribe(data => {
      if (data?.status === 'SYNC_COMPLETED') {
        if (this.isDmsSyncInProgress) {
          this.alertService.showAlert('otherTexts.syncedSuccessfully', '', '', 5000, false);
        }
        this.isDmsSyncInProgress = false;
        clearInterval(this.refreshInterval);
      } else if (data?.status === 'SYNC_FAILED') {
        this.isDmsSyncInProgress = false;
        clearInterval(this.refreshInterval);
      }
    })

    this.subs.allopcodes = this.allOpCodes$.subscribe(t => {
      this.allOpCodesArray = t;
      this.transformAllOpcodes();
    });

    this.subs.loading = this.loading$.subscribe(t => {
      this.loading = t
    });

   this.subs.selectIsAspCodeCreated = this.opCodeStore.select(fromSelector.selectIsAspCodeCreated).subscribe(opcode => {
      if(opcode?.opcode){
        if(opcode.isVisible){
          this.aspServiceCode = opcode; 
          this.allOpCodesForm.get('sortBy').setValue('alpha');
          this.onlineOpCodesForm.get('showOpCodes').setValue('all');
        }
        else{
          this.aspServiceCode = opcode; 
          // !important - Need to work on while working on create complaint code part
          const cat = this.aspServiceCode?.SK.split("#")[0] === 'MAINTENANCECODE' ? 'maintenanceOpcodes' : 'complaintOpcodes';
          this.selectionChanged([this.aspServiceCode], 1, cat);
          this.isSelected = 'all';
          this.allOpCodesForm.get('sortBy').setValue('alpha');
        }
        this.opCodeStore.dispatch(new OpCodeActions.ChangeIsAspCodeCreated());
      }
    });
  }

  getIntegrationText(){
    return this.isDmsIntegrated ? '' : this.translate.instant('otherTexts.notSubscribedToDmsIntegration')
  }

  autoRefreshSyncStatus() {
    this.refreshInterval = setInterval(() => {
      this.opCodeStore.dispatch(new OpCodeActions.LoadSyncStatus());
    }, 10 * 1000)
  }



  loadOnlineOpCodeDetails() {

    this.opCodeStore.dispatch(new OpCodeActions.LoadOnlineOpCodes({
      sort: this.allOpCodesForm.get('sortBy').value,
      order: this.allOpCodesForm.get('sortOrder').value,
      limit: '500',
      query: this.allOpCodesForm.get('searchQuery').value
    }));

    this.opCodeStore.dispatch(new OpCodeActions.LoadOnlineSortOrder());

    this.opCodeStore.dispatch(new OpCodeActions.LoadSyncStatus());


    this.subs.onlinesortingdetails = this.opCodeStore.select(fromSelector.selectOnlineSortingDetails).subscribe(sortDetails => {
      this.onlineServicesSortOrder = sortDetails;
      this.onlineOpCodesForm.get('sortBymaintenanceOpcodes').setValue(this.onlineServicesSortOrder?.onlineOpcodeSortDetail?.by?.maintenance === OnlineOpcodeSortBy.CUSTOM ? OnlineOpcodeSortBy.CUSTOM : OnlineOpcodeSortBy.ALPHA);
      this.onlineOpCodesForm.get('sortBycomplaintOpcodes').setValue(this.onlineServicesSortOrder?.onlineOpcodeSortDetail?.by?.complaint === OnlineOpcodeSortBy.CUSTOM ? OnlineOpcodeSortBy.CUSTOM : OnlineOpcodeSortBy.ALPHA);
      this.onlineOpCodesForm.get('sortBydmsOpcodes').setValue(this.onlineServicesSortOrder?.onlineOpcodeSortDetail?.by?.dms === OnlineOpcodeSortBy.CUSTOM ? OnlineOpcodeSortBy.CUSTOM : OnlineOpcodeSortBy.ALPHA);
    });

    this.subs.selectonlineopcodelist = this.opCodeStore.select(fromSelector.selectOnlineOpCodesList).subscribe(t => {
      this.onlineOpcodesArray = t;
      this.onlineOpCodesCount = t.length;
      this.transformOnlineOpcodes();
    });



  }
  propComparator(sortValues) {
    return (a: IServiceOpcode, b: IServiceOpcode) => {
      return sortValues?.indexOf(a.opcode) - sortValues?.indexOf(b.opcode);
    }
  }


  initializeForm() {
    this.opCodeListForm = this.fb.group({
      allOpCodesForm: this.fb.group({
        searchQuery: [''],
        sortBy: [AllOpcodeSortBy.ALPHA],
        sortOrder: [SortOrder.ASC]
      }),
      onlineOpCodesForm: this.fb.group({
        showOpCodes: ['all'],
        sortBymaintenanceOpcodes: [''], 
        sortBycomplaintOpcodes: [''],
        sortBydmsOpcodes: ['']
      })
    });

    this.subs.searchQueryfromform = this.allOpCodesForm.get('searchQuery').valueChanges.pipe(debounceTime(300)).subscribe((_t) => {
      this.transformAllOpcodes();
    });

    this.subs.allsortbyfromform = this.allOpCodesForm.get('sortBy').valueChanges.subscribe(_t => {
      this.transformAllOpcodes();
    });

    this.subs.onlinesortbyfromform = this.onlineOpCodesForm.get('showOpCodes').valueChanges.subscribe(_t => {
      this.transformOnlineOpcodes();
    });
  }

  onlineSortOrderChange(_$event, category) {
    switch(category) {
      case 'maintenanceOpcodes': 
      this.onlineOpCodesForm.get('sortBymaintenanceOpcodes').value === OnlineOpcodeSortBy.ALPHA ?  this.removeCustomSortConfirmation('maintenanceOpcodes') :
      this.updateCustomSortOrder('maintenanceOpcodes');
      break;
      case 'complaintOpcodes': 
      this.onlineOpCodesForm.get('sortBycomplaintOpcodes').value === OnlineOpcodeSortBy.ALPHA ?  this.removeCustomSortConfirmation(category) :
      this.updateCustomSortOrder(category);
      break;
      case 'dmsOpcodes': 
      this.onlineOpCodesForm.get('sortBydmsOpcodes').value === OnlineOpcodeSortBy.ALPHA ?  this.removeCustomSortConfirmation(category) :
      this.updateCustomSortOrder(category);
      break;
      default:
        break;
    }
  }

  updateCustomSortOrder(category: string) {
    const onlineSortOrder: IOnlineCodeSortDetail = {
      onlineCustomSortOrder: {
        maintenance: (category === 'maintenanceOpcodes' ? this.onlineOpcodes[category]?.map(ev=> ev?.opcode) : this.onlineServicesSortOrder?.onlineCustomSortOrder?.maintenance || []),
        complaint: (category === 'complaintOpcodes' ? this.onlineOpcodes[category]?.map(ev=> ev?.opcode) : this.onlineServicesSortOrder?.onlineCustomSortOrder?.complaint || []),
        dms: (category === 'dmsOpcodes' ? this.onlineOpcodes[category]?.map(ev=> ev?.opcode) : this.onlineServicesSortOrder?.onlineCustomSortOrder?.dms || [])    
      },
      onlineOpcodeSortDetail: {
        by: {
          maintenance: this.onlineOpCodesForm.get('sortBymaintenanceOpcodes').value,
          complaint: this.onlineOpCodesForm.get('sortBycomplaintOpcodes').value,
          dms: this.onlineOpCodesForm.get('sortBydmsOpcodes').value
        },
        order: this.onlineServicesSortOrder.onlineOpcodeSortDetail.order,
      }
    }
    this.opCodeStore.dispatch(new OpCodeActions.UpdateOnlineSortOrder({ onlineSortOrder }));
    this.transformOnlineOpcodes();
  }

  getOnlineCustomSortOrder(category) {
    return {maintenance: (category === 'maintenanceOpcodes' ? [] : this.onlineServicesSortOrder?.onlineCustomSortOrder?.maintenance || []),
    complaint: (category === 'complaintOpcodes' ? [] : this.onlineServicesSortOrder?.onlineCustomSortOrder?.complaint || []),
    dms: (category === 'dmsOpcodes' ? [] : this.onlineServicesSortOrder?.onlineCustomSortOrder?.dms || [])
  }    
  }

  removeCustomSortConfirmation(category: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, this.removeCustomSortConfig);
    this.subs.dialogclosed = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        const onlineSortOrder: IOnlineCodeSortDetail = {
          onlineCustomSortOrder: this.getOnlineCustomSortOrder(category),
          onlineOpcodeSortDetail: {
            by: {
              maintenance: this.onlineOpCodesForm.get('sortBymaintenanceOpcodes').value,
              complaint: this.onlineOpCodesForm.get('sortBycomplaintOpcodes').value,
              dms: this.onlineOpCodesForm.get('sortBydmsOpcodes').value
            },
            order: this.onlineServicesSortOrder.onlineOpcodeSortDetail.order,
          }
        }
        this.opCodeStore.dispatch(new OpCodeActions.UpdateOnlineSortOrder({ onlineSortOrder }));
        this.transformOnlineOpcodes();
      }
      else if(category === 'maintenanceOpcodes'){
        this.onlineOpCodesForm.get('sortBymaintenanceOpcodes').setValue(OnlineOpcodeSortBy.CUSTOM);
      }
      else if (category === 'complaintOpcodes')
      {
        this.onlineOpCodesForm.get('sortBycomplaintOpcodes').setValue(OnlineOpcodeSortBy.CUSTOM);
      }
      else{
        this.onlineOpCodesForm.get('sortBydmsOpcodes').setValue(OnlineOpcodeSortBy.CUSTOM);
      }

    });
  }

  get allOpCodesForm() {
    return this.opCodeListForm.get('allOpCodesForm') as UntypedFormGroup;
  }

  get onlineOpCodesForm() {
    return this.opCodeListForm.get('onlineOpCodesForm') as UntypedFormGroup;
  }

  get sortOrder() {
    return this.allOpCodesForm.get('sortOrder').value;
  }

  get onlineShowOpCodes() {
    return this.onlineOpCodesForm.get('showOpCodes').value;
  }

  onSortOrderChange() {
    this.isSortingAllOpcodes = true;
    this.allOpCodesForm.get('sortOrder').setValue(this.allOpCodesForm.get('sortOrder').value === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC);
    this.sortedAllOpcodes.reverse();
    this.allOpCodes = this.GroupOpcodes(this.sortedAllOpcodes);
    this.isSortingAllOpcodes = false;
  }

  reloadOpCodes() {
    if (this.aspServiceCode === null) {
      this.opCodeStore.dispatch(new OpCodeActions.LoadAllOpCodes({
        sort: this.allOpCodesForm.get('sortBy').value,
        order: this.allOpCodesForm.get('sortOrder').value,
        limit: this.limit.toString(),
        query: this.allOpCodesForm.get('searchQuery').value
      }));
      this.opCodeStore.dispatch(new OpCodeActions.LoadOpCodesCount());
    }
    else if (this.aspServiceCode && !this.aspServiceCode.isVisible) {
      this.aspServiceCode = null;
    }
  }

  setSelectedOpcode(opCode: string, opCodeListIndex) {
    this.selectedOpcode = opCode;
    this.isAllOpCodeList = (opCodeListIndex === 1); // 1 === All opcodes list in the ui
  }

  itemsRemoved(ev, list) {
  }

  itemsAdded(ev: IServiceOpcode[], list) {
  }

  itemsUpdated(ev, category) {

    if (category === 'maintenanceOpcodes') {
      this.onlineOpCodesForm.get('sortBymaintenanceOpcodes').setValue(OnlineOpcodeSortBy.CUSTOM)
    } else if (category === 'complaintOpcodes') {
      this.onlineOpCodesForm.get('sortBycomplaintOpcodes').setValue(OnlineOpcodeSortBy.CUSTOM)
    }
    else {
      this.onlineOpCodesForm.get('sortBydmsOpcodes').setValue(OnlineOpcodeSortBy.CUSTOM);
    }

    const onlineSortOrder: IOnlineCodeSortDetail = {
      onlineCustomSortOrder: {
        maintenance: (category === 'maintenanceOpcodes' ? ev.map(t => t.opcode) : this.onlineServicesSortOrder?.onlineCustomSortOrder?.maintenance || []),
        complaint: (category === 'complaintOpcodes' ? ev.map(t => t.opcode) : this.onlineServicesSortOrder?.onlineCustomSortOrder?.complaint || []),
        dms: (category === 'dmsOpcodes' ? ev.map(t => t.opcode) : this.onlineServicesSortOrder?.onlineCustomSortOrder?.dms || [])
      },
      onlineOpcodeSortDetail: {
        by: {
              maintenance: this.onlineOpCodesForm.get('sortBymaintenanceOpcodes').value,
              complaint: this.onlineOpCodesForm.get('sortBycomplaintOpcodes').value,
              dms: this.onlineOpCodesForm.get('sortBydmsOpcodes').value
            },
        order: this.onlineServicesSortOrder.onlineOpcodeSortDetail.order,
      }
    }
      this.opCodeStore.dispatch(new OpCodeActions.UpdateOnlineSortOrder({ onlineSortOrder }));
  }

  getSelectedOpcodeList(Opcodes: any) {
    const keys = Object.keys(Opcodes);
    const list = [];
    if (keys.length) {
      keys.forEach(key => {
        list.push(...Opcodes[key])
      })
    }
    return list;
  }

  selectionChanged(ev, list, category) {

    if (list === 1) {
      this.selectedOpcodeListFromAllCategory[category] = ev;
      this.selectedOpcodeListFromAll = this.getSelectedOpcodeList(this.selectedOpcodeListFromAllCategory);
    }
    else if (list === 2) {
      this.selectedOpcodeListFromOnlineCategory[category] = ev;
      this.selectedOpcodeListFromOnline = this.getSelectedOpcodeList(this.selectedOpcodeListFromOnlineCategory);
    }

    if (!!ev[0] && !!ev[0].opcode) {
      const opCode = (ev.length === 1) ? ev[0].opcode : null;
      this.setSelectedOpcode(opCode, list);
    }
  }

  updateFromDms() {
    this.isDmsSyncInProgress = true;
    this.opCodeStore.dispatch(new OpCodeActions.UpdateFromDms());
    this.autoRefreshSyncStatus();
  }

  updateServiceStatus(status: boolean) {
    if ((this.selectedOpcodeListFromAll.length > 0 === status) ||
      (this.selectedOpcodeListFromOnline.length > 0  !== status) ) {
      for (const opcode of (status ? this.selectedOpcodeListFromAll : this.selectedOpcodeListFromOnline)) {
        if (status !== opcode.isVisible){
          this.opCodeStore.dispatch(new OpCodeActions.UpdateOpCode({ opcode: { ...opcode, isVisible: status, dmsDescription: opcode?.isInternalCode ? '(Not applicable for ASP Complaint Codes)' : opcode.dmsDescription }, 
          isLoadNotificationData: ((this.onlineOpCodesCount === 0 && status) ||  (this.onlineOpCodesCount === 1 && !status)) ? true : false }));
        }
      }
    }
  }

  updateMiscOpCode() {
    const dialogRef = this.dialog.open(OtherServiceOpcodeComponent, { panelClass: this.aspModalContainer });
    this.subs.dialogclosed = dialogRef.afterClosed().subscribe((event) => {
    });
  }

  createNewOpcode(){
    const dialogRef = this.dialog.open(CreateOpcodeFormComponent, {
      width: '650px',
      height: '720px',
      panelClass: this.aspModalContainer,
      disableClose:true,
      data:{clicked:true}
    });

    this.subs.dialogRefSub = dialogRef.afterClosed().subscribe(result => {
      
     });
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }
  clearAspSelected(event){
    if(event){
      this.isSelected = null;
      this.index = -1;
    }
  }
  isSelectedOpcodesValid(ev){
    return ev?.every((opcode) => opcode.opcode && opcode.displayName && opcode.description && opcode.labourHours && (opcode?.labourHours > 0) &&
      (opcode.opcodeType === OpcodeType.MAINTENANCE ? !!opcode.mileages : true)  && (opcode?.isInternalCode ? opcode?.mapDmsCode && opcode?.mapDmsCode?.opcode : true));
  }

  preventExpansion($event) {
    $event.stopPropagation();
  }

  GroupOpcodes(opcodes) {
    return _.groupBy(opcodes, (obj) => {
      const key = obj.SK?.split("#")[0]
      if (key === "OPCODE") {
        return "dmsOpcodes"
      } else if (key === "MAINTENANCECODE") {
        return "maintenanceOpcodes"
      } else if (key === "COMPLAINTCODE") {
        return "complaintOpcodes"
      } else {
        return key
      }
    });
  }

  searchOpcodes(query, opcodes) {
    return opcodes.filter(e=> e.opcode.toLowerCase().includes(query) || e.displayName?.toLowerCase()?.includes(query) ||
    e.description?.toLowerCase().includes(query) || 
    (e?.isInternalCode ? e.mapDmsCode?.opcode.toLowerCase().includes(query)  : false) || 
    ((e?.isInternalCode && e.subComplaints?.complaintCodes?.length) ? (e.subComplaints?.complaintCodes.some( x=> (x.displayName.toLowerCase().includes(query) ||
     x?.dmsCode?.toLowerCase().includes(query)))) : false));
  }

  transformAllOpcodes() {
    this.isSortingAllOpcodes = true;
    this.sortedAllOpcodes = [];
    const opcodes = this.allOpCodesArray;
    const sort = this.allOpCodesForm.get('sortBy').value;
    const order = this.allOpCodesForm.get('sortOrder').value;
    const query = this.allOpCodesForm.get('searchQuery').value.toLowerCase();
    let filterOpcodes = [];
    if (sort === AllOpcodeSortBy.ALPHA) {
      filterOpcodes = opcodes;
    }
    else if (sort === 'online') {
      filterOpcodes = opcodes.filter(e => e.isVisible);
    }
    else {
      filterOpcodes = opcodes.filter(e => !e.isVisible);
    }
    this.sortedAllOpcodes = query ? this.searchOpcodes(query, filterOpcodes) : filterOpcodes;
    this.sortedAllOpcodes.sort((a, b) => a?.displayName?.localeCompare(b?.displayName));
    if(order === SortOrder.DESC) 
    {
      this.sortedAllOpcodes.reverse();
    }
    this.allOpCodes = this.GroupOpcodes(this.sortedAllOpcodes);
    this.allOpCodes.dmsOpcodes?.sort((a, b) => (a?.opcode || '').localeCompare(b?.opcode || '', undefined, { sensitivity: 'base' }));
    this.isSortingAllOpcodes = false;
  }
  transformOnlineOpcodes() {
    const opcodes = this.onlineOpcodesArray;
    const show = this.onlineOpCodesForm.get('showOpCodes').value;
    let filterOpcodes = [];
    if (show === 'setupNeeded') {
      filterOpcodes = opcodes.filter(opcode => !(opcode.opcode && opcode.displayName && opcode.description && opcode.labourHours &&
        (opcode.opcodeType === OpcodeType.MAINTENANCE ? !!opcode.mileages : true) && (opcode?.isInternalCode ? opcode?.mapDmsCode && opcode?.mapDmsCode?.opcode : true)));
    }
    else if (show === 'recommended') {
      filterOpcodes = opcodes.filter(x => x.recommended.isRecommended);
    }
    else {
      filterOpcodes = opcodes;
    }
    const groupedOpcodes: IServiceOpcodes = this.GroupOpcodes(filterOpcodes);

    groupedOpcodes.maintenanceOpcodes = this.onlineOpCodesForm.get('sortBymaintenanceOpcodes').value === OnlineOpcodeSortBy.CUSTOM ?
      groupedOpcodes.maintenanceOpcodes?.sort(this.propComparator(this.onlineServicesSortOrder?.onlineCustomSortOrder?.maintenance)) :
      groupedOpcodes.maintenanceOpcodes?.sort((a, b) => a?.displayName?.localeCompare(b?.displayName));

    groupedOpcodes.complaintOpcodes = this.onlineOpCodesForm.get('sortBycomplaintOpcodes').value === OnlineOpcodeSortBy.CUSTOM ?
      groupedOpcodes.complaintOpcodes?.sort(this.propComparator(this.onlineServicesSortOrder?.onlineCustomSortOrder?.complaint)) :
      groupedOpcodes.complaintOpcodes?.sort((a, b) => a?.displayName?.localeCompare(b?.displayName));

    groupedOpcodes.dmsOpcodes = this.onlineOpCodesForm.get('sortBydmsOpcodes').value === OnlineOpcodeSortBy.CUSTOM ?
      groupedOpcodes.dmsOpcodes?.sort(this.propComparator(this.onlineServicesSortOrder?.onlineCustomSortOrder?.dms)) :
      groupedOpcodes.dmsOpcodes?.sort((a, b) => (a?.opcode || '').localeCompare(b?.opcode || '', undefined, { sensitivity: 'base' }));
    this.onlineOpcodes = groupedOpcodes;
  }
}
